// 清空数据
export const CLEARDATA = 'CLEARDATA';
// 设置区域列表参数
export const ZONEPARAMDATA = 'ZONEPARAMDATA';
// 设置区域模板id
export const ZONETEMPLATID = 'ZONETEMPLATID';
// 设置区域状态 
export const ZONESTATE = 'ZONESTATE';
// 设置区域数据
export const SETZONEDATA = 'SETZONEDATA';
// 设置区域列表数据
export const SETNEWLIST = 'SETNEWLIST';
// 区域单据 函数 
export const ZONEDATAFUN = 'ZONEDATAFUN';
// 多语
export const JSON = 'JSON';
export const SETTEMPLATEFUN = 'SETTEMPLATEFUN';